// extracted by mini-css-extract-plugin
export default {"menuBlock":"FM-z","title":"GM-z","nav":"HM-z","flexCell":"IM-z","facetLink":"JM-z"};